import { getApiConfig } from '@/api/config/client/getApiConfig';
import { ProductHeaders } from '@/api/headers';
import { ApiLogger } from '@/api/logger/apiLogger';
import { osDetector } from '@/api/osDetector/client';
import { type ConfigResult } from '@/api/types/configTypes';

import { parseConfigResult } from '../parsers/parseConfigResult';
import { HttpClient, type HttpOptions } from './httpClient';

const apiConfig = getApiConfig();
const { apiKey, isLogEnabled, productBaseUrl } = apiConfig;

export class ConfigClient {
  public constructor(private httpClient: HttpClient) {}

  /**
   * Gets the uri for Shorts feed page
   */
  public async getShortsFeedPageUri(short_id: string, size?: number, include_context = false): Promise<string> {
    const config = await this.getConfig();

    const templateUri = config.template_uris.shorts_explore_feed_uri;

    let uri = templateUri
      .replace(/short_id=/g, `short_id=${short_id}`)
      .replace(/include_context=\d+/g, `include_context=${include_context}`);

    if (size) {
      uri = uri.replace(/size=\d+/g, `size=${size}`);
    }

    return uri;
  }

  public async getConfig(options?: HttpOptions): Promise<ConfigResult> {
    const config = await this.httpClient.get<Partial<ConfigResult>>('/product/config/v1/init', options);

    return parseConfigResult(config);
  }
}

const logger = new ApiLogger('ConfigClient', isLogEnabled);
const headers = new ProductHeaders(apiKey);
const httpClient = new HttpClient({ apiConfig, baseUrl: productBaseUrl, logger, headers, osDetector });

export const configClient = new ConfigClient(httpClient);
